"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnScroll = useOnScroll;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

function useOnScroll(ref, options, deps) {
  var containerElement = ref === null || ref === void 0 ? void 0 : ref.current;
  var handleScroll = (0, _react.useCallback)(function () {
    options === null || options === void 0 ? void 0 : options.onScroll(containerElement);

    if (!(containerElement !== null && containerElement !== void 0 && containerElement.scrollTop) || containerElement.scrollTop < 100) {
      return;
    }

    if ((containerElement === null || containerElement === void 0 ? void 0 : containerElement.scrollTop) + (containerElement === null || containerElement === void 0 ? void 0 : containerElement.clientHeight) + 50 >= (containerElement === null || containerElement === void 0 ? void 0 : containerElement.scrollHeight)) {
      options === null || options === void 0 ? void 0 : options.atBottom();
    }
  }, [].concat((0, _toConsumableArray2["default"])(deps), [containerElement === null || containerElement === void 0 ? void 0 : containerElement.clientHeight, containerElement === null || containerElement === void 0 ? void 0 : containerElement.scrollHeight, containerElement === null || containerElement === void 0 ? void 0 : containerElement.scrollTop]));
  (0, _react.useEffect)(function () {
    containerElement === null || containerElement === void 0 ? void 0 : containerElement.addEventListener("scroll", handleScroll);
    return function () {
      return containerElement === null || containerElement === void 0 ? void 0 : containerElement.removeEventListener("scroll", handleScroll);
    };
  }, [containerElement, handleScroll]);
  return {
    scrollTop: containerElement === null || containerElement === void 0 ? void 0 : containerElement.scrollTop
  };
}